export const NFT_TEMPLATE_V1 = 1
export const NFT_TEMPLATE_V2 = 2

const normalizeAddress = (address) => (address || '').toLowerCase()

export function resolveNftTemplateId({ factoryTemplateId, contractTemplateVersion }) {
    const factoryId = Number(factoryTemplateId || 0)
    if (factoryId > 0) return factoryId
    return Number(contractTemplateVersion || 0) === NFT_TEMPLATE_V2 ? NFT_TEMPLATE_V2 : NFT_TEMPLATE_V1
}

export function isNftConsoleAdmin({ templateId, creator, owner, account }) {
    const currentAccount = normalizeAddress(account)
    if (!currentAccount) return false

    const authority = Number(templateId) === NFT_TEMPLATE_V2 ? owner : creator
    return normalizeAddress(authority) === currentAccount
}

export function shouldShowPublicMintControls({ isOnlyAdmin }) {
    return isOnlyAdmin === false
}
